import videoGallery from '../../data/videoGallery';
import {VideoQuestionSummary} from '../../data/videoQuestionSummary';
import {LectureObjectives} from '../../data/lectureObjectives';
import {videoDescription} from '../../data/videoDescription';
import {getChapterPartById, ACTION_GET_CHAPTER_PART_INFO, attachVideoToChapterPart, videoUploaded, videoDeleted} from './chapterPartActions';
import * as ChapterPartActions from "./chapterPartActions";
import api from '../../utils/api';
import {NotificationManager} from 'react-notifications';
import {logoutUserAction} from './authActions';

/* global btoa */

export const DEFAULT_STATE = 'DEFAULT_STATE';

export const ACTION_VIDEO_INITIALIZE = 'ACTION_VIDEO_INITIALIZE';
export const ACTION_LOAD_BLANK_VIDEO = 'ACTION_LOAD_BLANK_VIDEO';
export const ACTION_GET_VIDEO_QUESTION_SUMMERY = 'ACTION_GET_VIDEO_QUESTION_SUMMERY';
export const ACTION_GET_LECTURE_OBJECTIVES = 'ACTION_GET_LECTURE_OBJECTIVES';
export const ACTION_GET_VIDEO_DESCRIPTION = 'ACTION_GET_VIDEO_DESCRIPTION';
export const ACTION_UPLOAD_PROGRESS = 'ACTION_UPLOAD_PROGRESS';
export const ACTION_TEST_SUBMITTED = 'ACTION_TEST_SUBMITTED';

// User course
export const ACTION_USER_SUBJECT_RETRIEVED = 'ACTION_USER_SUBJECT_RETRIEVED';
export const ACTION_COURSE_USER_RETRIEVED = 'ACTION_COURSE_USER_RETRIEVED';

export const ACTION_VIDEO_FILE_RETRIEVED = 'ACTION_VIDEO_FILE_RETRIEVED';
export const ACTION_CHAPTER_PART_RETRIEVED = 'ACTION_CHAPTER_PART_RETRIEVED';
export const VIDEO_TIME_SYNC = 'VIDEO_TIME_SYNC';
export const RESET_CHAPTER_TESTS = 'RESET_CHAPTER_TESTS';

// Discussion
export const ACTION_POSTED_DISCUSSION = 'ACTION_POSTED_DISCUSSION';
export const ACTION_POSTED_DISCUSSION_COMMENT = 'ACTION_POSTED_DISCUSSION_COMMENT';
export const ACTION_LIKE_POSTED = 'ACTION_LIKE_POSTED';
export const ACTION_LIKE_DELETED = 'ACTION_LIKE_DELETED';
export const ACTION_FOLLOW_POSTED = 'ACTION_FOLLOW_POSTED';
export const ACTION_FOLLOW_DELETED = 'ACTION_FOLLOW_DELETED';
export const ACTION_GOT_DISCUSSION = 'ACTION_GOT_DISCUSSION';
export const ACTION_DELETED_DISCUSSION = 'ACTION_DELETED_DISCUSSION';
export const ACTION_DELETED_COMMENT = 'ACTION_DELETED_COMMENT';

// Video Questions
export const ACTION_USER_QUESTION_RETRIEVED = 'ACTION_USER_QUESTION_RETRIEVED';
export const ACTION_USER_QUESTION_UPDATED = 'ACTION_USER_QUESTION_UPDATED';
export const ACTION_USER_QUESTION_ADDED = 'ACTION_USER_QUESTION_ADDED';
export const ACTION_USER_QUESTIONS_RESET = 'ACTION_USER_QUESTIONS_RESET';

// Tests
export const ACTION_TEST_RETRIEVED = 'ACTION_TEST_RETRIEVED';
export const ACTION_SUBMIT_TEST = 'ACTION_SUBMIT_TEST';
export const ACTION_TEST_SCORED = 'ACTION_TEST_SCORED';
export const DELETED_VIDEO = 'DELETED_VIDEO';

export const COURSE_STATUS_UPDATED = 'COURSE_STATUS_UPDATED';
export const UPDATED_NOTIFICATIONS = 'UPDATED_NOTIFICATIONS';
export const FLAG_ADDED = 'FLAG_ADDED';
export const ACTION_EDITED_CU = 'ACTION_EDITED_CU';
export const UPDATED_COURSE_USER = 'UPDATED_COURSE_USER';
export const LOADED_SLIM_COURSE = 'LOADED_SLIM_COURSE';
export const ADD_SLIM_LECTURE = 'ADD_SLIM_LECTURE';

export function getVideoInitialAction(course) {
    return {
        type: ACTION_VIDEO_INITIALIZE,
        payload: course
    }
}

export function updateFlags(data){
    return {
        type: FLAG_ADDED,
        payload: data
    }
}

function gotChapterPart(results){
    return {
        type: ACTION_CHAPTER_PART_RETRIEVED,
        payload: results
    }
}

export function postedDiscussion(comment){
    return {
        type: ACTION_POSTED_DISCUSSION,
        payload: comment
    }
}

export function postedLike(like){
    return {
        type: ACTION_LIKE_POSTED,
        payload: like
    }
}

export function deletedLike(like){
    return {
        type: ACTION_LIKE_DELETED,
        payload: like
    }
}

export function postedFollow(follow){
    return {
        type: ACTION_FOLLOW_POSTED,
        payload: follow
    }
}

export function deletedFollow(follow){
    return {
        type: ACTION_FOLLOW_DELETED,
        payload: follow
    }
}

function deletedVideo(){
    return {
        type: DELETED_VIDEO
    }
}

export function postLike(like, token){
    return dispatch => {
        api.postLike(like, token, res => {
            dispatch(postedLike(res.data));
        })
    }
}

export function deleteLike(like, token){
    return dispatch => {
        api.deleteLike(like, token, res => {
            dispatch(deletedLike(like));
        })
    }
}

function userChapterPartTestRetrieved(test){
    return {
        type: ACTION_TEST_RETRIEVED,
        payload: test
    }
}

export function deleteVideo(video, token){
    return dispatch => {
        api.deleteVideo(video, token, res => {
            dispatch(videoDeleted())
            dispatch(deletedVideo());
        })
    }
}

export function getUserChapterPartTest(chapterPartId, userId, token){
    return dispatch => {
        api.getUserChapterPartTest(chapterPartId, userId, token, res => {
            if(res){
                let passedTest = res.data.filter(t => t.correctPercent >= 80);
                if(passedTest.length > 0){
                    dispatch(userChapterPartTestRetrieved(passedTest[0]));
                }else{
                    dispatch(userChapterPartTestRetrieved({}));
                }
            }
        })
    }
}

function userTestScored(results){
    return {
        type: ACTION_TEST_SCORED,
        payload: results
    }
}

function userTestSubmitted(){
    return {
        type: ACTION_TEST_SUBMITTED,
        payload: []
        
        
    }
}

export function scoreTest(test, token){
    return dispatch => {
        dispatch(userTestSubmitted())
        // console.log("Test", test);
        api.scoreUserChapterPartTest(test, token, res => {
            dispatch(userTestScored(res.data.test));
        })
    }
}

export function fakeScoreTest(test, token){
    return dispatch => {
        dispatch(userTestSubmitted())
        api.fakeScoreUserChapterPartTest(test, token, res => {
            dispatch(userTestScored(res.data));
        })
    }
}

export function postDiscussion(comment, user, token){
    return dispatch => {
        api.postDiscussion(comment, user, token, res => {
            if(res.status === 200){
                dispatch(postedDiscussion(res.data));
            }
        })
    }
}

export function postedComment(comment){
    return {
        type: ACTION_POSTED_DISCUSSION_COMMENT,
        payload: comment
    }
}

function gotVideoDiscussion(discussion){
    return {
       type: ACTION_GOT_DISCUSSION,
       payload: discussion
    }
}

function deletedDiscussion(id){
    return {
        type: ACTION_DELETED_DISCUSSION,
        payload: id
    }
}

function deletedComment(id){
    return {
        type: ACTION_DELETED_COMMENT,
        payload: id
    }
}

export function deleteAllDiscussions(chapterVideoId, token){
    return dispatch => {
        api.deleteAllDiscussions(chapterVideoId, token, res => {
            dispatch(gotVideoDiscussion([]))
        })
    }
}

export function deleteDiscussion(id, token){
    return dispatch => {
        api.deleteDiscussion(id, token, res => {
            dispatch(deletedDiscussion(id));
        })
    }
}

export function deleteComment(id, token){
    return dispatch => {
        api.deleteComment(id, token, res => {
            dispatch(deletedComment(id));
        })
    }
}

export function getVideoDiscussion(chapterVideoId, token){
    return dispatch => {
        api.getVideoDiscussion(chapterVideoId, token, res => {
            dispatch(gotVideoDiscussion(res.data));
        })
    }
}

export function postComment(comment, user, token){
    return dispatch => {
        api.postComment(comment, user, token, res => {
            if(res.status === 200){
                dispatch(postedComment(res.data));
            }
        })
    }
}

function setLoading(){
    return {
        type: 'UPDATE_LOADING',
        payload: true
    }
}

export function gotUserLecture(lecture){
    return {
        type: 'USER_LECTURE_RETRIEVED',
        payload: lecture
    }
}

export function gotDiagnosticUserLecture(lecture){
    return {
        type: 'DIAG_USER_LECTURE_RETRIEVED',
        payload: lecture
    }
}

export function getUserLectureFromOldRoute(id, courseUser, subjectAttempt, courseAttempt, userSubject, token){
    return dispatch => {
        dispatch(setLoading());
        dispatch({
            type: 'CANVIEW_FALSE'
        })
        api.getUserLecture(id, courseUser.id, subjectAttempt, userSubject, token, res => {
            if(!userSubject.id && res.data.length > 0){
                dispatch(getUserSubject(courseUser.profileId, res.data[res.data.length - 1].Lecture.courseId, res.data[res.data.length - 1].Lecture.subjectId, token))
            }
            // if lecture get all related data, otherwise create

            if(res.data.length > 0){
                dispatch(gotUserLecture(res.data[res.data.length - 1]));
                if(!res.data[res.data.length - 1].UserChapter){
                    api.createUserChapter(res.data[res.data.length - 1].Lecture.subjectChapterId, courseUser.id, courseUser.profileId, courseUser.userId, userSubject.id,  token, res2 => {
                        // update lecture with userChapterId:
                        res.data[res.data.length - 1].userChapterId = res2.data.id;
                        dispatch(updateUserLecture(res.data[res.data.length - 1]));
                    });
                }
            }else if(courseUser.currentChapterPart === id || courseUser.role === 'admin'){
                api.createUserLecture(id, courseUser.id, subjectAttempt, courseAttempt, userSubject, token, res => {
                    
                    api.getUserLecture(id, courseUser.id, subjectAttempt, userSubject, token, res2 => {
                        dispatch(gotUserLecture(res2.data[res2.data.length - 1]));
                        if(!userSubject.id && res2.data.length > 0){
                            dispatch(getUserSubject(courseUser.profileId, res2.data[res2.data.length - 1].Lecture.courseId, res2.data[res2.data.length - 1].Lecture.subjectId, token))
                        }
                        api.createUserChapter(res2.data[res2.data.length - 1].Lecture.subjectChapterId, courseUser.id, courseUser.profileId, courseUser.userId, userSubject.id,  token, res3 => {
                            // update lecture with userChapterId:
                            res2.data[res2.data.length - 1].userChapterId = res3.data.id;
                            dispatch(updateUserLecture(res2.data[res2.data.length - 1]));
                        });

                    })
                })
            }else{
                dispatch({
                    type: 'CANVIEW_NO'
                })
            }
        })
    }
}

export function getUserLecture(id, profileId, token){
    return dispatch => {
        dispatch(setLoading());
        dispatch({
            type: 'CANVIEW_FALSE'
        })

        api.getUserLecture(id, profileId, token, res => {
            // console.log("REG", res);
            if(!res.data.error){
                dispatch({
                    type: 'VIDEO_LECTURE_RETRIEVED',
                    payload: res.data
                })
            }else{
                dispatch({
                    type: 'VIDEO_LOAD_ERROR',
                    payload: res.data.error
                })
                dispatch({
                    type: 'CANVIEW_NO'
                })
            }
        })
    }
}

export function getUserLectureOlder(id, courseUser, subjectAttempt, courseAttempt, userSubject, token){
    return dispatch => {
        dispatch(setLoading());
        dispatch({
            type: 'CANVIEW_FALSE'
        })

        /*
        api.getUserLecture(id, profileId, token, res => {
            if(!res.data.error){

            }
        })
*/
        // Old code used for retreiving user subject and lecture
        /*
        api.getUserLecture(id, courseUser.id, subjectAttempt, userSubject, token, res => {
            if(!userSubject.id){
                dispatch(getUserSubject(courseUser.profileId, res.data[res.data.length - 1].Lecture.courseId, res.data[res.data.length - 1].Lecture.subjectId, token))
            }

            // if lecture get all related data, otherwise create
            // console.log("V Filtered:", res.data.filter(v => v.active && (v.type !== 'test' || v.type === 'test' && !v.completed)));
            // console.log("US", userSubject);
            if(res.data.filter(v => v.active && (v.type !== 'test' || v.type === 'test' && !v.completed)).length > 0){
                // console.log("Got lecture?", res.data);
                dispatch(gotUserLecture(res.data[res.data.length - 1]));
                if(!res.data[res.data.length - 1].UserChapter){
                    api.createUserChapter(res.data[res.data.length - 1].Lecture.subjectChapterId, courseUser.id, courseUser.profileId, courseUser.userId, userSubject.id,  token, res2 => {
                        // update lecture with userChapterId:
                        res.data[res.data.length - 1].userChapterId = res2.data.id;
                        dispatch(updateUserLecture(res.data[res.data.length - 1]));
                    });
                }
            }else if(courseUser.currentChapterPart === id || res.data.length > 0 || (courseUser.currentSubject === userSubject.courseSubjectId && userSubject.Subject.type === 'review')){
                api.createUserLecture(id, courseUser.id, subjectAttempt, courseAttempt, userSubject, token, res => {
                    api.getUserLecture(id, courseUser.id, subjectAttempt, userSubject, token, res2 => {
                        dispatch(gotUserLecture(res2.data[res2.data.length - 1]));
                        api.createUserChapter(res2.data[res2.data.length - 1].Lecture.subjectChapterId, courseUser.id, courseUser.profileId, courseUser.userId, userSubject.id,  token, res3 => {
                            // update lecture with userChapterId:
                            res2.data[res2.data.length - 1].userChapterId = res3.data.id;
                            dispatch(updateUserLecture(res2.data[res2.data.length - 1]));
                        });

                    })
                })
            }else{
                dispatch({
                    type: 'CANVIEW_NO'
                })
            }
        })
        */
    }
}

export function getUserChapterPart(id, token){
    return dispatch => {
        dispatch(setLoading());
        api.getUserChapterPart(id, token, res => {
            dispatch(gotChapterPart(res.data));
        })
    }
}

function gotUserVideoQuestions(q){
    return {
        type: ACTION_USER_QUESTION_RETRIEVED,
        payload: q
    }
}

function userQuestionAdded(question){
    return {
        type: ACTION_USER_QUESTION_ADDED,
        payload: question
    }
}

function userQuestionUpdated(question){
    return {
        type: ACTION_USER_QUESTION_UPDATED,
        payload: question
    }
}



export function updateVideoQuestion(question, token){
    return dispatch => {
        if(!question.id){
            api.addUserVideoQuestion(question, token, res => {
                dispatch(userQuestionAdded(res.data));
            })
        }else{
            api.updateUserVideoQuestion(question, token, res => {
                dispatch(userQuestionUpdated(res.data));
            })
        }
    }
}

export function fakeUpdateQuestion(question){
    return dispatch => {
        if(question.id){
            dispatch(userQuestionUpdated(question));
        }else{
            // Fake an id
            question.id = btoa(new Date().getHours() + new Date().getMinutes() + new Date().getSeconds() + new Date().getMilliseconds() * 10000000);
            dispatch(userQuestionAdded(question));
        }
        
    }
}

export function getUserVideoQuestions(chapterVideoId, profileId, token){
    return dispatch => {
        api.getUserVideoQuestions(chapterVideoId, profileId, token, res => {
            dispatch(gotUserVideoQuestions(res.data));
        })
    }
}

export function getUserCourseContent(courseId, token){
    return dispatch => {
        api.getUserCourse(courseId, token, res => {
            if(res.status === 200){
                dispatch(getVideoInitialAction(res.data));
            }
        })


    }
}

function gotUserSubject(sub){
    return {
        type: ACTION_USER_SUBJECT_RETRIEVED,
        payload: sub
    }
}

export function clearState(){
    return {
        type: DEFAULT_STATE
    }
}

export function addQuizQuestion(quizId, question, mode, token) {
    return dispatch => {
        api.addUserQuizQuestion(quizId, question, mode, token, res => {
            dispatch({
                type: 'GOT_UL_QUIZ_QUESTION',
                payload: res.data.test
            });

        })
    }
}

export function getOrMakeQuiz(userLectureId, token){
    return dispatch => {
        api.getOrMakeQuiz(userLectureId, token, res => {
            // console.log("GOT QUIZ", res);
            dispatch({
                type: 'GOT_UL_QUIZ',
                payload: res.data.test
            })
        })
    }
}

export function getCourseAndSubjects(courseId, token){
    return dispatch => {
        api.getCourseAndSubjects(courseId, token, res => {
            dispatch({
                type: 'GOT_COURSE_AND_SUBJECTS',
                payload: res.data
            });
        });
    }
}

export function getCompletedSubjects(cuid, token){
    return dispatch => {
        api.getCompletedSubjects(cuid, token, res => {
            dispatch({
                type: 'GOT_COMPLETED_SUBJECTS',
                payload: res.data
            });
        });
    }
}

export function getCompletedUserLectures(usid, token){
    return dispatch => {
        api.getCompletedUserLectures(usid, token, res => {
            dispatch({
                type: 'GOT_COMPLETED_USER_LECTURES',
                payload: res.data
            });
        })
    }
}

export function getUserSubject(profileId, courseId, subjectId, token){
    return dispatch => {

        api.getSingleCourseUser(profileId, courseId, token, res => {
            if(res.status == 401){
                logoutUserAction();
            }
            if (res.status == 200) {
                
                
                dispatch(gotSingleCourseUser(res.data));
                api.getUserSubject(subjectId, res.data, token, res2 => {
                    // console.log("Got us?", res2.data);
                    if(res2.status == 401){
                        logoutUserAction();
                    }
                    if(res2.status == 200){
                        if(res2.data.length > 0){
                            dispatch(gotUserSubject(res2.data[0])); 
                            if(res2.data[0].Subject){
                            res2.data[0].Subject.CourseChapter.map(ch => {
                                
                                api.getUserSubjectContent(ch.id, res.data, token, res5 => {
                                    dispatch({
                                        type: 'GOT_USER_SUBJECT_CHAPTERS',
                                        payload: res5.data
                                    })
                                })
                                
                            })
                        }
                        }else{
                            api.createUserSubject(subjectId, res.data, token, res3 => {
                                if(res3.data){
                                    api.getUserSubject(subjectId, res.data, token, res4 => {
                                        if(res4.status == 401){
                                            logoutUserAction();
                                        }else{
                                            
                                            dispatch(gotUserSubject(res4.data[0])); 
                                            res4.data[0].Subject.CourseChapter.map(ch => {
                                                api.getUserSubjectContent(ch.id, res.data, token, res5 => {
                                                    dispatch({
                                                        type: 'GOT_USER_SUBJECT_CHAPTERS',
                                                        payload: res5.data
                                                    })
                                                })
                                            })
                                        }
                                    });
                                }
                            })
                        }
                        
                    }
                })
            }
        })


        
    }
}

export function gotCourseUsers(data){
    return {
        type: ACTION_COURSE_USER_RETRIEVED,
        payload: data
    }
}

export function updatedCourseUser(data){
    return {
        type: UPDATED_COURSE_USER,
        payload: data
    }
}


export function createCourseNotification(notification, token){
    return dispatch => {
        notification.createdAt = new Date();
        notification.date = new Date();
        // console.log("Creating", notification);
        api.createCourseNotification(notification, token, res => {
            // console.log("Success?", res);
        })    
    }
    
}

export function gotSingleCourseUser(cu){
    return {
        type: 'GOT_SINGLE_COURSE_USER',
        payload: cu
    }
}

export function getMoreNotifications(courseId, created, profileId, skip, token){
    return dispatch => {
        api.getMoreNotifications(courseId, created, profileId, skip, token, res2 => {
            // console.log("got", res2);
            dispatch({
                type: 'EXPAND_NOTIFICATIONS',
                payload: res2.data
            })

            if(res2.data.length < 20){
                dispatch({
                    type: 'CHECK_NOTIFICATIONS',
                    payload: false
                })
            }else{
                dispatch({
                    type: 'CHECK_NOTIFICATIONS',
                    payload: true
                })
            }
        })
    }
}

export function getNotifications(courseId, created, profileId, token){
    return dispatch => {
        api.getCourseNotifications(courseId, created, profileId, token, res2 => {
            // console.log("got", res2);
            dispatch({
                type: 'GOT_NOTIFICATIONS',
                payload: res2.data
            })

            if(res2.data.length < 6){
                dispatch({
                    type: 'CHECK_NOTIFICATIONS',
                    payload: false
                })
            }else{
                dispatch({
                    type: 'CHECK_NOTIFICATIONS',
                    payload: true
                })
            }
        })
    }
}

export function getSingleCourseUser(profileId, courseId, token){
    return dispatch => {
        if(profileId) {
        api.getSingleCourseUser(profileId, courseId, token, res => {
            if(res.status == 401){
                logoutUserAction();
            }
            if (res.status == 200) {
                
                dispatch(gotSingleCourseUser(res.data));
                // console.log("got course user, now getting notes");
                // Get Course Notifications
                api.getCourseNotifications(courseId, res.data.created, profileId, token, res2 => {
                    // console.log("got", res2);
                    dispatch({
                        type: 'GOT_NOTIFICATIONS',
                        payload: res2.data
                    })
                })
            }
        })
        }
    }
}


export function getCourseUser(profileId, token){
    
        return dispatch => {
            if(profileId) {
            api.getCourseUsers(profileId, token, res => {
                if(res.status == 401){
                    logoutUserAction();
                }
                if (res.status == 200) {
                    
                    dispatch(gotCourseUsers(res.data));
                }
            })
            }
        }
    
}

export function updateCourseUser(courseUser, profileId, token){
    return dispatch => {
        api.updateCourseUser(courseUser, token, res => {
            if(res.status == 401){
                    logoutUserAction();
                }
            dispatch(getSingleCourseUser(profileId, courseUser.courseId, token));
        });
    }
}

export function setDefaultUploadProgress(){
    return {
        type: 'RESET_VIDEO_PROGRESS'
    }
}

export function getVideoQuestionSummary() {
    return {
        type: ACTION_GET_VIDEO_QUESTION_SUMMERY,
        payload: VideoQuestionSummary
    }
}

export function getLectureObjectives() {
    return {
        type: ACTION_GET_LECTURE_OBJECTIVES,
        payload: LectureObjectives
    }
}

export function getVideoDescription() {
    return {
        type: ACTION_GET_VIDEO_DESCRIPTION,
        payload: videoDescription
    }
}

export function internalVideoUpdate(video){
    return {
        type: ACTION_VIDEO_FILE_RETRIEVED,
        payload: video
    }
}

export function loadBlankVideo(){
    return {
        type: ACTION_LOAD_BLANK_VIDEO,
        payload: {}
    }
}

export function updateVideoProgress(progress){
    return {
        type: ACTION_UPLOAD_PROGRESS,
        payload: {progress: progress}
    }
}

export function editedCourseUser(cu){
    return {
        type: ACTION_EDITED_CU,
        payload: cu
    }
}

export function loadVideoById(id, token){
    return (dispatch) => {
        api.loadVideoById(id, token, res => {
            
           if(res.status === 200){
               dispatch(internalVideoUpdate(res.data));
           }
        });
    }
}

export function uploadSubtitles(file, videoId, token){
    return dispatch => {
        api.uploadSubtitles(file, videoId, token, res => {
            if(res.status === 200){
                dispatch(internalVideoUpdate(res.data));
                NotificationManager.success("Subtitles uploaded successfully");
            }else{
                NotificationManager.error(`The server responded with a ${res.status} code`, "Upload failed");
            }
        })
    }
}

export function uploadVideo(file, chapterPartId, duration, token){
    return (dispatch) => {
        api.uploadVideoFile(file, chapterPartId, duration,  token, res => {
            if(res.status === 200){
                dispatch(videoUploaded(res.data));
                dispatch(internalVideoUpdate(res.data));
                NotificationManager.success("Video uploaded successfully", "Video Uploaded");
            }else{
                NotificationManager.error(`The server responded with a ${res.status} code`, "Upload failed");
            }
        }, progress => {
            dispatch(updateVideoProgress(progress));
        })
    }
}

export function uploadVideoCreate(file, lecture, duration, token){
    return dispatch => {
        api.addChapterVideo(lecture, lecture.subjectChapterId, token, res1 => {
            if(res1.status === 200){
                
                
                dispatch(loadBlankVideo());
                dispatch(addSlimLecture(res1.data));
                dispatch(ChapterPartActions.addChapterPartInfo(res1.data));
                api.uploadVideoFile(file, res1.data.id, duration, token, res => {
                    if(res.status === 200){
                        dispatch(videoUploaded(res.data));
                        dispatch(internalVideoUpdate(res.data));
                        NotificationManager.success("Video uploaded successfully", "Video Uploaded");
                    }else{
                        NotificationManager.error(`The server responded with a ${res.status} code`, "Upload failed");
                    }
                }, progress => {
                    dispatch(updateVideoProgress(progress));
                })
            }
        })
        
    }
}

function resetVideoQuestions(q){
    return {
        type: ACTION_USER_QUESTIONS_RESET,
        payload: q
    }
}

function resetChapterTests(t){
    return {
        type: RESET_CHAPTER_TESTS,
        payload: t
    }
}

export function deleteUserVideoQuestions(videoId, profileId, token){
    return dispatch => {
        api.deleteUserVideoQuestions(videoId, profileId, token, res => {
            dispatch(resetVideoQuestions(res.data));
        })
    }
}

export function updateCurrentQuestion(quizId, mode, t, token){
    return dispatch => {
        api.updateCurrentQuestion(quizId, mode, t, token, res => {
            dispatch({
                type: 'GOT_UL_QUIZ_QUESTION',
                payload: res.data.test
            });
        });
    }
}

export function deleteChapterTests(testId, profileId, token){
    return dispatch => {
        api.deleteChapterTests(testId, profileId, token, res => {
            //dispatch(resetChapterTests(res.data));
        })
    }
}

function videoTimeSynced(cu){
    return {
        type: VIDEO_TIME_SYNC,
        payload: cu
    }
}

function flagsRetrieved(flags){
    return {
        type: 'GOT_FLAGS',
        payload: flags
    }
}

export function getFlags(cu, token){
    return dispatch => {
        api.getFlags(cu, token, res => {
            dispatch(flagsRetrieved(res.data));
        });
    }
}

function gotLogs(logs){
    return {
        type: 'GOT_LOGS',
        payload: logs
    }
}

function addedLog(log){
    return {
        type: 'ADDED_LOG',
        payload: log
    }
}

export function createLog(log, token){
    return dispatch => {
        api.createLog(log, token, res => {
            dispatch(addedLog(res.data));
        })
    }
}

function updatedLog(log){
    return {
        type: 'UPDATED_LOG',
        payload: log
    }
}

export function updateLog(log, token){
    return dispatch => {
        api.updateLog(log, token, res => {
            dispatch(updatedLog(res.data));
        })
    }
}

export function getLogs(cu, range, token){
    return dispatch => {
        api.getLogs(cu, range, token, res => {
            dispatch(gotLogs(res.data));
        });
    }
}

export function getCourseUserFlags(cu, token){
    return dispatch => {
        api.getCourseUserFlags(cu, token, res => {
            dispatch(flagsRetrieved(res.data));
        });
    }
}

export function updatedUserLecture(ul){
    return {
        type: 'USER_LECTURE_UPDATED',
        payload: ul
    }
}

export function addedUserLecture(ul){
    return {
        type: 'ADDED_USERLECTURE',
        payload: ul
    }
}

export function removedQuiz(id){
    return {
        type: 'REMOVED_QUIZ',
        payload: id
    }
}

export function removedUserLecture(id){
    return {
        type: 'REMOVED_USERLECTURE',
        payload: id
    }
}

export function updateUserLecture(ul, token, success){
    return dispatch => {
        api.updateUserLecture(ul, token, res => {
            dispatch(updatedUserLecture(res.data));
            if(success){
                success();
            }
        });
    }
}

export function getTestCourse(courseId, token){
    return dispatch => {
        api.getTestCourseAndLectures(courseId, token, res => {
            dispatch({
                type: 'GOT_TEST_COURSE',
                payload: res.data
            })
        })
    }
}

export function getUserLectureTests(courseUserId, token){
    return dispatch => {
        api.getUserLectureTests(courseUserId, token, res => {
            dispatch({
                type: 'GOT_USER_LECTURE_TESTS',
                payload: res.data
            })
        })
    }
}

export function getSyllabus(cuId){
    return dispatch => {
        api.getSyllabus(cuId, res => {
            dispatch({
                type: 'GOT_SYLLABUS',
                payload: res.data
            })
        })
    }
}

export function enrichTest(id, token){
    return dispatch => {
        dispatch({
            type: 'TEST_DETAILS',
            payload: {}
        })
        api.enrichTest(id, token, res => {
            dispatch({
                type: 'TEST_DETAILS',
                payload: res.data
            })
        })
    }
}

export function enrichQuiz(id, token){
    return dispatch => {
        dispatch({
            type: 'QUIZ_DETAILS',
            payload: {}
        })
        api.enrichQuiz(id, token, res => {
            dispatch({
                type: 'QUIZ_DETAILS',
                payload: res.data.length > 0 ? res.data[0] : {}
            })
        })
    }
}

export function sendStat(stat, token){
    return dispatch => {
        api.sendStat(stat, token, (res) => {

        })
    }
}

export function syncVideoTime(cu, ul, token){
    return dispatch => {
        api.updateCourseUser(cu, token, res => {
            dispatch(videoTimeSynced(res.data));
        });

        api.updateUserLecture(ul, token, res => {
            dispatch(updatedUserLecture(res.data));

            const newHourlyStat = {
                courseId: ul.courseId,
                result: 60,
                type: "kpiVideoTime",
                statType: "hourly",
                persistent: false,
                totalScores: 0,
                totalItems: 0
            };

            const newStat = {
                courseId: ul.courseId,
                result: 60,
                type: "kpiVideoTime",
                statType: "daily",
                persistent: false,
                totalScores: 0,
                totalItems: 0
            };

            api.sendStat(newHourlyStat, token, (res) => {

            })

            api.sendStat(newStat, token,(res) => {

            })

            const newHourlyStat1 = {
                courseId: ul.courseId,
                result: 60,
                type: "watchTime",
                statType: "hourly",
                persistent: false,
                totalScores: 0,
                totalItems: 0
            };

            const newStat1 = {
                courseId: ul.courseId,
                result: 60,
                type: "watchTime",
                statType: "daily",
                persistent: false,
                totalScores: 0,
                totalItems: 0
            };

            api.sendStat(newHourlyStat1, token, (res) => {

            })

            api.sendStat(newStat1, token, (res) => {

            })

        });
    }
}

export function updateCourseNotifications(data){
    return {
        type: UPDATED_NOTIFICATIONS,
        payload: data
    }
}

export function updateCourseStatus(data){
    return {
        type: COURSE_STATUS_UPDATED,
        payload: data.courseStatus
    }
}

export function updateQuestionNumbers(questions, token){
    return dispatch => {
        api.updateQuestionNumbers(questions, token, res => {

        })
    }
}

export function sendFeedback(feedback, token){
    return dispatch => {
        api.sendFeedback(feedback, token, res => {
        })
    }
}

function loadedSlimCourse(course){
    return {
        type: LOADED_SLIM_COURSE,
        payload: course
    }
}

export function updateSlimLecture(lecture){
    return {
        type: 'UPDATE_SLIM_ITEM',
        payload: lecture
    }
}


export function loadSlimCourses(courseId, token){
    return dispatch => {
        api.loadSlimCourse(courseId, token, res => {
            dispatch(loadedSlimCourse(res.data));
        })
    }
}

export function addSlimLecture(lecture){
    return {
        type: ADD_SLIM_LECTURE,
        payload: lecture
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/videoActions.js